// validateParentDomain.js

const allowedProdDomain = "clubready.com";
const allowedDevDomains = [
  "clubreadydev.com",
  "clubreadytest.com",
  "clubreadystage.com",
  "clubreadystage1.com",
  "clubreadystage2.com",
];

const IS_PRODUCTION = process.env.REACT_APP_ENV === "production";

export function isParentDomainValid(origin: any) {
  if (IS_PRODUCTION) {
    return origin.includes(allowedProdDomain);
  } else {
    return allowedDevDomains.some((domain) => origin.includes(domain));
  }
}